module.exports = __webpack_public_path__ + "img/desktop_team_top_img.3c6e9fbe.jpg";